import type { DocumentPreviewResponse, PdftronDoc } from './types'

export function documentPreviewToDocs(
  response: DocumentPreviewResponse | null | undefined
): PdftronDoc[] {
  if (!response) return []
  if (response.tabs && response.tabs.length > 0) {
    return response.tabs.map((tab) => ({ url: tab.url }))
  }
  return response.url ? [{ url: response.url }] : []
}
